import commonTableColumns from '@root/components/table/commonTableColumns';
import CountTooltip from '@root/components/Tooltip/CountTooltip';
import Text from '@root/components/v2/ui-elements/Text';
import Tooltip from '@root/components/v2/ui-elements/Tooltip';
import EllipsesCountTooltip from '@root/components/v3/ellipsesCountTooltip';
import { VulnerabilityCounts } from '../VulnerabilityCounts';
import { Box } from '@mui/material';

export const sbomColumns = [
  commonTableColumns.environment('account_id', 'cluster'),
  {
    field: 'name',
    headerName: 'Image',
    width: 300,
    renderCell: params => {
      return (
        <Tooltip tooltip={params.row.name}>
          <Text className="SingleLine" fontWeight={500}>
            {params.row.name}
          </Text>
        </Tooltip>
      );
    },
  },
  {
    field: 'workload',
    headerName: 'Workload',
    renderCell: params => {
      return (
        <Box display={'flex'} flexDirection={'column'} gap={'4px'}>
          <EllipsesCountTooltip labels={params?.row?.related_workloads?.map(item => item.workload_name) ?? []} />
          <EllipsesCountTooltip labels={params?.row?.related_workloads?.map(item => item.workload_kind) ?? []} />
        </Box>
      );
    },
    width: 200,
  },

  {
    field: 'namespace',
    headerName: 'Namespace',
    width: 200,
    renderCell: params => {
      return <CountTooltip labels={params?.row?.namespace} />;
    },
  },
  // {
  //   field: 'cluster',
  //   headerName: 'Cluster',
  //   width: 230,
  // },

  {
    field: 'vulnerabilities',
    headerName: 'Vulnerabilities',
    width: 300,
    renderCell: params => {
      return params?.row?.vulnerability_counts ? (
        <VulnerabilityCounts vulnerabilities={params.row.vulnerability_counts} />
      ) : (
        '-'
      );
    },
  },
];
